import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetRenewalSettings } from '@/graphql/contracts/_generated_/getRenewalSettings.query';
import GetRenewalSettingsQuery from '@/graphql/contracts/getRenewalSettings.query.gql';
import { notificationService } from '@/services/notification/notification.client';

export default function useGetRenewalSettings() {
  const [getRenewalSettings, { data, loading }] = useLazyQuery<GetRenewalSettings>(
    GetRenewalSettingsQuery,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      fetchPolicy: 'cache-first'
    }
  );

  return {
    getRenewalSettings,
    renewalSettings: data?.renewalSettings || [],
    isLoadingGetRenewalSettings: loading
  } as const;
}
